import _mergeJSXProps4 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps3 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { HTMLElementType, emitter } from '@cloud-sn/v-utils';
import Align from '@cloud-sn/v-align';
export default {
  components: {
    Align: Align
  },
  mixins: [emitter],
  props: {
    prefixCls: {
      type: String,
      default: ''
    },
    className: {
      type: [String, Array, Object],
      default: ''
    },
    styles: {
      type: Object,
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    getClassNameFromAlign: {
      type: Function,
      default: function _default() {
        return '';
      }
    },
    rootDomNode: {
      type: HTMLElementType(),
      default: null
    },
    align: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    destroyPopupOnHide: {
      type: Boolean,
      default: false
    },
    transition: {
      type: String,
      default: ''
    },
    animation: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      innerAlign: {},
      xVisible: false,
      dVisible: false
    };
  },
  computed: {
    transitionName: function () {
      var prefixCls = this.prefixCls,
          transition = this.transition,
          animation = this.animation;
      var transitionName = transition;

      if (!transition && animation) {
        transitionName = "".concat(prefixCls, "-").concat(animation);
      }

      return transitionName;
    },
    target: function target() {
      return this.rootDomNode;
    },
    alignClass: function alignClass() {
      var innerAlign = this.innerAlign,
          getClassNameFromAlign = this.getClassNameFromAlign;
      return getClassNameFromAlign(innerAlign);
    },
    classes: function classes() {
      var prefixCls = this.prefixCls,
          alignClass = this.alignClass;
      return [prefixCls, alignClass];
    }
  },
  watch: {
    align: function align(nVal) {
      if (nVal) {
        this.setInnerAlign(nVal);
      }
    },
    visible: function visible(nVal) {
      if (nVal === false) {
        this.xVisible = nVal;
      } else {
        this.dVisible = false;
      }
    }
  },
  created: function created() {
    this.setInnerAlign(this.align);
  },
  methods: {
    setInnerAlign: function setInnerAlign(align) {
      this.innerAlign = align;
    },
    getTarget: function getTarget() {
      return this.rootDomNode;
    },
    onAlign: function onAlign(element, align) {
      this.setInnerAlign(align);
      this.xVisible = this.visible;
      this.$emit('on-align', element, align);
    },
    onAfterEnter: function onAfterEnter() {
      this.$emit('afterenter');
    },
    onAfterLeave: function onAfterLeave() {
      this.dVisible = true;
    },
    renderTransitionAlign: function renderTransitionAlign(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var h = this.$createElement;
      var transitionName = this.transitionName;
      var transitionAttrs = {
        props: _objectSpread({
          name: transitionName,
          appear: true
        }, options.props),
        on: _objectSpread({}, options.on)
      };
      return transitionName ? h("transition", _mergeJSXProps([{}, transitionAttrs]), [element]) : element;
    },
    renderPopup: function renderPopup() {
      var _this = this;

      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          destroyPopupOnHide = this.destroyPopupOnHide,
          visible = this.visible,
          xVisible = this.xVisible,
          dVisible = this.dVisible,
          $slots = this.$slots,
          classes = this.classes,
          className = this.className,
          styles = this.styles,
          getTarget = this.getTarget,
          align = this.align,
          onAlign = this.onAlign,
          onAfterLeave = this.onAfterLeave,
          onAfterEnter = this.onAfterEnter,
          transitionName = this.transitionName,
          renderTransitionAlign = this.renderTransitionAlign;
      var self = this;
      var popupInner = h("div", _mergeJSXProps2([{
        "directives": [{
          name: "show",
          value: xVisible
        }]
      }, {
        class: [classes, className],
        style: styles,
        attrs: {
          role: 'align-popup'
        },
        on: {
          mousedown: function mousedown(e) {
            self.broadcast('UxTrigger', 'onNestedPopupClick', e);
            e.stopPropagation();
          }
        }
      }]), [h("div", {
        "class": "".concat(prefixCls, "-content")
      }, [$slots.default])]);
      var alignAttrs = {
        props: {
          target: getTarget,
          align: align,
          disabled: !visible,
          monitorWinResize: true
        },
        on: {
          'on-align': onAlign
        },
        ref: 'alignRef'
      };

      if (xVisible && !transitionName) {
        this.$nextTick(function () {
          _this.$nextTick(function () {
            onAfterEnter();
          });
        });
      }

      if (destroyPopupOnHide) {
        // animate || no anomiate
        return transitionName && !dVisible || !transitionName && visible ? h(Align, _mergeJSXProps3([{}, alignAttrs]), [renderTransitionAlign(popupInner, {
          on: {
            afterEnter: onAfterEnter,
            afterLeave: onAfterLeave
          }
        })]) : null;
      }

      return h(Align, _mergeJSXProps4([{}, alignAttrs]), [renderTransitionAlign(popupInner, {
        on: {
          afterEnter: onAfterEnter
        }
      })]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var renderPopup = this.renderPopup;
    return h("div", {
      "attrs": {
        "role": "popup"
      }
    }, [renderPopup()]);
  }
};